export const SET_ORDERS_HISTORY = 'SET_ORDERS_HISTORY';
export const SET_ORDER_RATING = 'SET_ORDER_RATING';
